import { ChartPie, Star } from "lucide-react";

// Shown on the Favourites tab before any fund has been starred: a sketch of a
// starred row on the Mutual Funds page, pointing the user there.
export function FavouritesEmptyState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-8 overflow-auto rounded-lg border border-border bg-card px-6 py-12">
      <div aria-hidden className="flex w-full max-w-lg flex-col gap-6">
        <span className="flex w-fit items-center gap-4 rounded-lg bg-background pr-4 text-sm font-semibold shadow-sm">
          <span className="flex size-10 items-center justify-center rounded-lg border border-border bg-secondary">
            <ChartPie className="size-5" />
          </span>
          Mutual funds
        </span>
        <div className="flex items-center gap-4 rounded-lg bg-background p-4 text-sm shadow-md">
          <span className="size-8 shrink-0 rounded-md bg-destructive" />
          <span className="flex flex-1 flex-col gap-1">
            <span className="h-4 w-3/4 rounded-sm bg-secondary" />
            <span className="h-3 w-1/2 rounded-sm bg-secondary/60" />
          </span>
          <span className="w-16 text-right">₹500Cr</span>
          <span className="w-16 text-right text-tag-green-foreground">
            19.85%
          </span>
          <Star className="ml-4 size-5 fill-yellow-500 text-yellow-500" />
        </div>
      </div>
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-lg font-semibold">No favourite funds yet</span>
        <p className="max-w-60 text-sm text-muted-foreground">
          Mark your favourite funds on the Mutual Funds listing page
        </p>
      </div>
    </div>
  );
}
